<template>
  <section
    class="student-signup signup"
    :style="{
      'background-image': 'url(' + bucketUrl + '/assets/background_student.png)'
    }"
  >
    <header-logged-out type="student" />
    <v-container fill-height>
      <v-row no-gutters align="center" justify="center">
        <v-col cols="12" sm="10" md="8" lg="7" xl="5">
          <v-card>
            <form @submit.prevent="submit">
              <v-toolbar dark color="primary" flat>
                <v-toolbar-title>Student Registration</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <class-code
                  title="Student code"
                  v-model="classCode"
                  v-validate="'required|min:4'"
                  data-vv-name="class_code"
                  data-vv-as="student code"
                  hint="The student code must be supplied to you by a teacher"
                  data-vv-validate-on="change"
                  :error-messages="errors.collect('class_code')"
                />
                <password-strength
                  ref="passwordStrength"
                  v-model="passwordObj"
                  :label="'Password'"
                />
                <!-- <v-text-field
                  ref="password"
                  v-model="password"
                  name="password"
                  label="Enter your password"
                  hint="Make sure your password is 6 to 20 characters long"
                  min="6"
                  :append-icon="visible ? 'visibility' : 'visibility_off'"
                  @click:append="visible = !visible"
                  :error-messages="errors.collect('password')"
                  v-validate="'required|min:6|max:20'"
                  data-vv-name="password"
                  :type="visible ? 'text' : 'password'"
                />
                <v-text-field
                  v-model="passwordConfirmation"
                  name="password_confirmation"
                  label="Confirm your password"
                  hint="Make sure your password is 6 to 20 characters long"
                  min="6"
                  :append-icon="visible ? 'visibility' : 'visibility_off'"
                  @click:append="visible = !visible"
                  :error-messages="errors.collect('password_confirmation')"
                  v-validate="'required|confirmed:password'"
                  data-vv-name="password_confirmation"
                  data-vv-as="password confirmation"
                  :type="visible ? 'text' : 'password'"
                /> -->
                <v-checkbox
                  v-model="terms"
                  color="primary"
                  v-validate="'required'"
                  :error-messages="errors.collect('terms')"
                  data-vv-name="terms"
                  data-vv-as="terms and conditions"
                  class="terms-and-conditions"
                >
                  <template v-slot:label>
                    By checking this box, you agree to our&nbsp;
                    <a target="_blank" href="/privacy-policy" @click.stop>
                      Privacy Policy</a
                    >&nbsp;and
                    <a target="_blank" href="/terms-and-conditions" @click.stop>
                      Terms &amp; Conditions
                    </a>
                    <br />
                  </template>
                </v-checkbox>
              </v-card-text>
              <v-card-actions class="px-3 pb-3 pt-0">
                <div>
                  Already have an account?
                  <router-link to="/student/login" style="color: #1565c0">
                    Click here to log in.
                  </router-link>
                </div>
                <v-spacer />
                <v-btn
                  color="primary"
                  @click="submit"
                  :loading="loading"
                  :disabled="loading"
                >
                  Signup
                </v-btn>
              </v-card-actions>
            </form>
          </v-card>
        </v-col>
        <custom-snackbar />
      </v-row>
    </v-container>
  </section>
</template>

<script>
import ClassCode from '@/components/ClassCode'
import { mapMutations, mapState } from 'vuex'
import CustomSnackbar from '@/components/snackbar/snackbar'
import Student from '@/modules/student/models/Student'
import _ from 'lodash'
import HeaderLoggedOut from '@/modules/auth/views/HeaderLoggedOut'
import Class from '@/modules/class/models/Class'
import PasswordStrength from '@/components/PasswordStrength'

export default {
  name: 'Signup',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    ClassCode,
    CustomSnackbar,
    HeaderLoggedOut,
    PasswordStrength
  },
  data() {
    return {
      terms: null,
      cred: '',
      visible: false,
      password: '',
      passwordConfirmation: '',
      classCode: '',
      loading: false,
      passwordObj: null
    }
  },
  created() {
    this.classCode = this.$route.query.code ? this.$route.query.code : ''
    this.cred = this.$route.query.email
  },
  computed: {
    ...mapState(['bucketUrl', 'isSDECC'])
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar', 'showErrorSnackbar']),
    async submit() {
      let passwordResult = await this.$refs.passwordStrength.validate()
      if (!passwordResult) {
        return // there are errors
      }

      if (this.passwordObj.isWeak) {
        this.showErrorSnackbar('Your password is too weak')
        return // there are errors
      }

      let result = await this.$validator.validateAll()
      if (!result) {
        return // there are errors
      }
      try {
        let form = {
          username: this.classCode.toUpperCase(),
          password: this.passwordObj.password,
          password_confirmation: this.passwordObj.confirmpassword,
          class_invitation_code: this.classCode
        }
        this.loading = true
        const student = await Student.dispatch('register', { payload: form })

        await Student.dispatch('login', {
          payload: { password: form.password, username: form.username }
        })
        await Class.dispatch('fetchForStudent')
        this.showSnackbar(
          `Welcome ${
            this.isSDECC ? '' : this.capitalizeFirstLetter(student.email)
          }. You will be redirected to your class`
        )
        this.loading = false
        const classId = Class.query().first().id
        setTimeout(() => {
          this.$router.push(
            `/student/dashboard/classes?currentClassId=${classId}&currentParentTab=messages`
          )
        }, 2500)
      } catch (error) {
        let status = error.response.status
        this.loading = false
        if (status === 422) {
          const errors = error.response.data.errors
          const messages = _.map(errors, x => x)
          this.showErrorSnackbar(messages.join('\n'))
        } else if (status === 404) {
          if (error.response.data.message.includes('ClassInvitation')) {
            this.showErrorSnackbar(
              "Oops! That student code doesn't seem right. Double-check the one your teacher gave you."
            )
          } else {
            let errorMessage = `There was a server error. Contact support.\n ${error.message}: ${error.response.data.message}`
            this.showErrorSnackbar(errorMessage)
          }
        } else {
          let errorMessage = `There was a server error. Contact support.\n ${error.message}: ${error.response.data.message}`
          this.showErrorSnackbar(errorMessage)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.student-signup {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;
  .custom__class-code {
    margin: 0;
    align-items: flex-start;
  }
  .classCodeInput {
    input {
      text-transform: uppercase;
      letter-spacing: 5px;
    }
  }
}
</style>
